import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Note } from 'src/app/entities/note';
import { NoteService } from 'src/app/services/note.service';

@Component({
  selector: 'app-track-notes',
  templateUrl: './track-notes.component.html',
  styleUrls: ['./track-notes.component.css']
})
export class TrackNotesComponent {

    totalNotes = 0;
    notes: Note[];
    content: string;
    track = this.data.track;
    note: Note;

    constructor(private noteService: NoteService, private  dialogRef: MatDialogRef<TrackNotesComponent>,
                @Inject(MAT_DIALOG_DATA) public data: TrackNotesComponent) { }

    onClose() {
        this.dialogRef.close();
    }
}




